/**
 * @ngdoc service
 * @name app.photosService
 * @description
 * # photosService
 * Service to talk with backend api.
 * @requires app.apiService
 * @requires constants:config
 * @requires ng.$q
 * @requires ng.$timeout
 **/

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * CONSTANTS
\*---------------------------------------------------------*/
const deps = {};
/*---------------------------------------------------------*\
 * photosService
\*---------------------------------------------------------*/
/* @ngInject */
function photosService(apiService, config, $q, $timeout) {
  deps.apiService = apiService;
  deps.config = config;
  deps.$q = $q;
  deps.$timeout = $timeout;

  /**
   * @ngdoc
   * @name app.photosService#getPhotoList
   * @methodOf app.photosService
   * @example
   * ``` js
   * photosService.getPhotoList('LI');
   * ```
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of three characters.
   * @description
   * Service to talk with backend api. It calls the apiService.wrap function,
   * passing a relative url, the string '/photos/list/', and the passed in region code.
   * @returns {httpPromise} Promise that will resolve into an array of photos
   * objects or an empty one;
   **/
  this.getPhotoList = (regionId) => {
    return deps.apiService.wrap(deps.config.relBaseUrlAPi + '/photos/list/' + regionId,
      {}, 'photos')
      .then((res) => {
        return res.data || [];
      });
  };
}

photosService.$inject = [
  'apiService',
  'config',
  '$q',
  '$timeout'
];

const api = angular
  .module('photosService', ['config', 'apiService'])
  .service('photosService', photosService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/photos.js
 **/